module.exports = __webpack_public_path__ + "img/login-background.bd8d9f4f.jpg";